<div class="loading-indicator-container">
  <div class="loading-indicator">
    <div class="loading-indicator__dot loading-indicator__dot-1"></div>
    <div class="loading-indicator__dot loading-indicator__dot-2"></div>
    <div class="loading-indicator__dot loading-indicator__dot-3"></div>
    <div class="loading-indicator__dot loading-indicator__dot-4"></div>
    <div class="loading-indicator__dot loading-indicator__dot-5"></div>
  </div>
  <div class="loading-indicator-text">Loading, please wait.</div>
</div>